import React, { useState, useEffect } from 'react';
import StandartLayout from '../layouts/StandartLayout';
import axios from "axios";
import { rootURL } from "../constants";
import { useNavigate } from "react-router-dom";
import { useAuth } from '../auth/Auth';
import MicrosoftAuth from "../components/MicrosoftAuth";
import SlackAuth from "../components/SlackAuth";
import FirefliesAuth from "../components/FirefliesAuth";
import { getUserInfo, getUser, list_user_workspaces, add_user_to_workspace, remove_user_from_workspace, createInvitationToken, updateWorkspaceName, create_workspace, delete_workspace, getSlackWorkspaceName } from "../backendApi/backend";
import { useGlobalContext } from '../GlobalContext';


import { 
  Layout, 
  Typography, 
  Form, 
  Input, 
  Button, 
  Card, 
  Row, 
  Col,
  notification,
  Switch,
  Modal,
  List,
  Avatar,
  Tag,
  ConfigProvider,
  message
} from 'antd';
import { 
  EditOutlined, 
  LockOutlined, 
  SaveOutlined,
  PhoneOutlined,
  MailOutlined,
  CheckCircleOutlined,
  ApiOutlined,
  TeamOutlined,
  LinkOutlined,
  UserAddOutlined,
  UserOutlined,
  CloseOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  CopyOutlined
} from '@ant-design/icons';

const { Title, Text } = Typography;

// Design system constants using CSS variables from App.css
const COLORS = {
  background: 'var(--primary-bg-color)',
  cardBg: 'var(--card-bg-dark)',
  cardHeaderBg: 'transparent',
  border: '#444',
  textPrimary: 'var(--text-color)',
  textSecondary: '#ccc',
  textMuted: 'var(--text-light)',
  buttonPrimary: 'var(--primary-color)',
  buttonSecondary: '#2a2a2a',
  inputBg: 'transparent',
  contentBg: '#3a3a3a',
  successColor: 'var(--success-color)',
};

const SIZES = {
  borderRadius: '12px',
  cardShadow: 'var(--card-shadow)',
  buttonShadow: '0 2px 6px rgba(0,0,0,0.3)',
  spacing: {
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  },
};

const cardStyle = {
  width: '100%',
  borderRadius: SIZES.borderRadius,
  boxShadow: SIZES.cardShadow,
  overflow: 'hidden',
  background: COLORS.cardBg,
  border: 'none',
  height: '100%',
};

const cardHeadStyle = {
  background: COLORS.cardHeaderBg,
  borderBottom: `1px solid ${COLORS.border}`,
  padding: `${SIZES.spacing.md} ${SIZES.spacing.lg}`,
};

const cardBodyStyle = {
  padding: SIZES.spacing.lg,
};

// Add container styles for row alignment
const containerStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column' as 'column',
  height: '100%',
};

const buttonStyle = {
  primary: {
    background: COLORS.buttonPrimary,
    borderColor: COLORS.border,
    boxShadow: SIZES.buttonShadow,
    color: COLORS.background,
    fontWeight: 'bold',
  },
  secondary: {
    background: COLORS.buttonSecondary,
    borderColor: COLORS.border,
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    color: COLORS.textPrimary,
  }
};

const inputStyle = {
  background: COLORS.inputBg,
  borderColor: COLORS.border,
  color: COLORS.textPrimary,
};

// Add type definitions
interface User {
  id: number;
  name: string;
  email: string;
  role: string;
}

interface Workspace {
  id: string;
  name: string;
  members: number;
  users: User[];
  is_owner: boolean;
  member_count: number;
  alias_email: string;
}


function Settings() {
  const [profile, setProfile] = useState({
    name: '',
    surname: '',
    phone: '',
  });
  const [passwordForm] = Form.useForm();
  const [profileForm] = Form.useForm();
  const [username, setUserName] = useState('');
  const { isMobile, setIsMobile, refreshWorkspaces } = useGlobalContext();
  const [isEditing, setIsEditing] = useState(false);
  const auth = useAuth();
  const navigate = useNavigate();
  const [integrations, setIntegrations] = useState({
    microsoftTeams: { connected: false, status: 'Not Connected' },
    slack: { connected: false, status: 'Not Connected' },
    outlook: { connected: false, status: 'Not Connected' }
  });
  const [microsoftConnected, setMicrosoftConnected] = useState(false);
  const [slackConnected, setSlackConnected] = useState(false);
  const [firefliesConnected, setFirefliesConnected] = useState(false);
  const [workspaces, setWorkspaces] = useState<Workspace[]>([]);
  const [workspaceModalVisible, setWorkspaceModalVisible] = useState(false);
  const [selectedWorkspace, setSelectedWorkspace] = useState<Workspace | null>(null);
  const [inviteEmail, setInviteEmail] = useState('');
  const [editingWorkspaceName, setEditingWorkspaceName] = useState(false);
  const [workspaceName, setWorkspaceName] = useState('');
  const [inviteLoading, setInviteLoading] = useState(false);
  const [firefliesModalVisible, setFirefliesModalVisible] = useState(false);
  const [firefliesMeetings, setFirefliesMeetings] = useState([]);
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [createWorkspaceModalVisible, setCreateWorkspaceModalVisible] = useState(false);
  const [newWorkspaceName, setNewWorkspaceName] = useState('');
  const [createWorkspaceLoading, setCreateWorkspaceLoading] = useState(false);
  const [slackWorkspaceName, setSlackWorkspaceName] = useState('');

  const onPasswordFormFinish = async (values: any) => {
    console.log('Form submitted with values:', values); // Debug log
    const user = getUser();
    setPasswordLoading(true);
    
    try {
      const csrftoken = auth.getCookie('csrftoken');
      const tokensStr = window.localStorage.getItem("tokens");
      const currentToken = tokensStr ? JSON.parse(tokensStr) : null;
      const authHeader = currentToken?.access ? { 'Authorization': `Bearer ${currentToken.access}` } : {};
     
      const response = await axios.post(`${rootURL}/authentication/update-password/`, {'password': values.password, 'user': user}, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRFToken': csrftoken,
          ...authHeader
        },
        withCredentials: true
      });
      
      if (response.status === 200) {
        notification.success({
          message: 'Password Updated',
          description: 'Your password has been updated successfully. Please log in again.',
        });
        passwordForm.resetFields();
        auth.logout();
        navigate("/login");
      }
    } catch (error: any) {
      notification.error({
        message: 'Error',
        description: error.response?.data?.message || error.response?.data?.error || 'Failed to update password',
      });
      console.log(error);
    } finally {
      setPasswordLoading(false);
    }
  };

  const onPasswordFormFinishFailed = (errorInfo: any) => {
    console.log('Form validation failed:', errorInfo); // Debug log
  };

  const formatNameFromEmail = (email: string): string => {
    const localPart = email.split('@')[0];
    // Replace dots, hyphens, underscores with spaces and capitalize each word
    return localPart
      .replace(/[._-]/g, ' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  useEffect(() => {
    // Check Microsoft connection status based on azuread_token cookie
    const azureadToken = auth.getCookie('azuread_token');
    setMicrosoftConnected(!!azureadToken);

    // Check Slack connection status based on slack_access_token cookie
    const slackToken = auth.getCookie('slack_access_token');
    setSlackConnected(!!slackToken);

    // Fetch Slack workspace name if connected
    if (slackToken) {
      const fetchSlackWorkspaceName = async () => {
        try {
          const response = await getSlackWorkspaceName(slackToken);
          if (response.workspace_name) {
            setSlackWorkspaceName(response.workspace_name);
          }
        } catch (error) {
          console.error('Error fetching Slack workspace name:', error);
        }
      };
      fetchSlackWorkspaceName();
    }

    // Check Fireflies connection status based on fireflies_access_token cookie
    const firefliesToken = auth.getCookie('fireflies_access_token');
    setFirefliesConnected(!!firefliesToken);

    // Fetch real workspaces
    const fetchWorkspaces = async () => {
      try {
        const response = await list_user_workspaces();
        if (Array.isArray(response)) {
          const formattedWorkspaces = response.map(workspace => ({
            ...workspace,
            members: workspace.member_count || workspace.users?.length || 1,
            users: workspace.users || [],
            alias_email: workspace.alias_email || '', // Fallback if alias_email is not provided
          }));
          setWorkspaces(formattedWorkspaces);
        }
      } catch (error) {
        console.error('Error fetching workspaces:', error);
        notification.error({
          message: 'Error',
          description: 'Failed to fetch workspaces',
        });
      }
    };

    fetchWorkspaces();

    getUserInfo().then(({ updatedProfile }) => {
      if(updatedProfile) {
        if(updatedProfile.name !== '') {
          setProfile((prevProfile) => ({
            ...prevProfile,
            name: updatedProfile.name,
          }));
        }
        if(updatedProfile.phone !== '') {
          setProfile((prevProfile) => ({
            ...prevProfile,
            phone: updatedProfile.phone,
          }));
        }
        if(updatedProfile.surname !== '') {
          setProfile((prevProfile) => ({
            ...prevProfile,
            surname: updatedProfile.surname,
          }));
        }
      }
    }).catch(error => {
      console.error('Error updating user info:', error);
    });
  
    const fetchData = async () => {
      try {
        const fetchCsrfToken = async () => {
          try {
            await axios.get(`${rootURL}/authentication/set-csrf-token/`, { withCredentials: true });
          } catch (error) {
            console.error('Error fetching CSRF token:', error);
          }
        };
  
        const user = getUser();
        setUserName(user ? user : '');
        await fetchCsrfToken();
        
      } catch (error) {
        console.error('Error in fetchData:', error);
      }
    };
  
    fetchData();

  }, []);


  const handleProfileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setProfile(prevProfile => ({
      ...prevProfile,
      [name]: value
    }));
  };

  const updateUserInfo = () => {
    // Validate the profile form before updating
    profileForm.validateFields().then(() => {
      try {
        const user = getUser();
        var csrftoken = auth.getCookie('csrftoken');
        const payload: any = {
          'user': user,
          'name': profile.name,
          'surname': profile.surname,
          'phone': profile.phone
        };
        
        axios.post(`${rootURL}/authentication/update-user-info/`, payload, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': csrftoken
          },
          withCredentials: true  
        })
        .then(response => {
          notification.success({
            message: 'Profile Updated',
            description: 'Your profile information has been updated successfully',
            icon: <CheckCircleOutlined style={{ color: COLORS.successColor }} />
          });
        })
        .catch(error => {
          notification.error({
            message: 'Error',
            description: 'Failed to update profile',
          });
          console.error('Error updating user info:', error);
        });
      } catch (error) {
        console.error('Error updating user info:', error);
      }
    }).catch(errorInfo => {
      notification.error({
        message: 'Validation Error',
        description: 'Please fix the form errors before saving',
      });
      // wait a bit and then refresh page
        setTimeout(() => {
          window.location.reload();
        }, 500);
      console.log('Validation failed:', errorInfo);
    });
  };

  const toggleEdit = () => {
    if (isEditing) {
      updateUserInfo();
    }
    setIsEditing(!isEditing);
  };

  const handleCancelEdit = () => {
    // Reset form to original values
    profileForm.setFieldsValue(profile);
    setIsEditing(false);
  };

  const handleMicrosoftToggle = (checked: boolean) => {
    if (!checked) {
      // Disconnect Microsoft account by removing the cookie
      document.cookie = 'azuread_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      setMicrosoftConnected(false);
      notification.info({
        message: 'Microsoft Account Disconnected',
        description: 'Your Microsoft account has been disconnected successfully.',
      });
    }
  };

  const handleSlackToggle = (checked: boolean) => {
    if (!checked) {
      // Disconnect Slack account by removing the cookie
      document.cookie = 'slack_access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      setSlackConnected(false);
      notification.info({
        message: 'Slack Account Disconnected',
        description: 'Your Slack account has been disconnected successfully.',
      });
    }
  };

  const handleFirefliesToggle = (checked: boolean) => {
    if (!checked) {
      // Disconnect Fireflies account by removing the cookie
      document.cookie = 'fireflies_access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      setFirefliesConnected(false);
      notification.info({
        message: 'Fireflies Account Disconnected',
        description: 'Your Fireflies account has been disconnected successfully.',
      });
    } else {
      // Open Fireflies modal when switch is turned on
      setFirefliesModalVisible(true);
    }
  };


  const handleWorkspaceClick = (workspace: Workspace) => {
    setSelectedWorkspace(workspace);
    setWorkspaceName(workspace.name);
    setWorkspaceModalVisible(true);
  };

  const handleInviteUser = async () => {
    if (!inviteEmail) {
      notification.error({
        message: 'Error',
        description: 'Please enter an email address',
      });
      return;
    }

    if (!selectedWorkspace) {
      return;
    }

    setInviteLoading(true);

    try {
      // Call backend to add user to workspace
      await add_user_to_workspace(inviteEmail, selectedWorkspace.id, 'member');
      
      // Create invitation token
      const response = await createInvitationToken(inviteEmail);
      const fullUrl = response.url || ``;
      if (response.error) {
        notification.error({
          message: 'Error',
          description: response.error,
        });
        return;
      }

      // Add user to local state for immediate UI update
      const newUser: User = {
        id: Date.now(),
        name: formatNameFromEmail(inviteEmail),
        email: inviteEmail,
        role: 'member'
      };

      // Update selectedWorkspace state
      setSelectedWorkspace(prev => {
        if (!prev) return null;
        
        return {
          ...prev,
          users: [...prev.users, newUser],
          members: prev.members + 1,
          member_count: prev.member_count + 1
        };
      });

      // Update workspaces list to reflect the new member count
      setWorkspaces(prev => 
        prev.map(workspace => 
          workspace.id === selectedWorkspace.id 
            ? { 
                ...workspace, 
                users: [...workspace.users, newUser],
                members: workspace.members + 1,
                member_count: workspace.member_count + 1
              }
            : workspace
        )
      );

      setInviteEmail('');
      
      notification.success({
        message: 'User Invited',
        description: `Invitation sent to ${inviteEmail}. Link: ${fullUrl}`,
      });

      // Refetch workspaces to ensure data consistency
      try {
        const updatedWorkspaces = await list_user_workspaces();
        if (Array.isArray(updatedWorkspaces)) {
          const formattedWorkspaces = updatedWorkspaces.map(workspace => ({
            ...workspace,
            members: workspace.member_count || workspace.users?.length || 1,
            users: workspace.users || [],
          }));
          setWorkspaces(formattedWorkspaces);
          
          // Update selectedWorkspace with fresh data
          const updatedSelectedWorkspace = formattedWorkspaces.find(w => w.id === selectedWorkspace.id);
          if (updatedSelectedWorkspace) {
            setSelectedWorkspace(updatedSelectedWorkspace);
          }
        }
      } catch (error) {
        console.error('Error refetching workspaces:', error);
      }

    } catch (error: any) {
      notification.error({
        message: 'Error',
        description: error.response?.data?.error || 'Failed to invite user',
      });
    } finally {
      setInviteLoading(false);
    }
  };

  const handleRemoveUser = async (email: string) => {
    if (!selectedWorkspace) return;

    const userToRemove = selectedWorkspace.users.find(user => user.email === email);
    if (!userToRemove) return;

    try {
      // Call backend to remove user from workspace
      await remove_user_from_workspace(userToRemove.email, selectedWorkspace.id);
      
      // Update local state
      setSelectedWorkspace(prev => {
        if (!prev) return null;
        
        return {
          ...prev,
          users: prev.users.filter((user: User) => user.email !== email),
          members: prev.members - 1
        };
      });

      notification.success({
        message: 'User Removed',
        description: `${userToRemove.email} has been removed from the workspace`,
      });
    } catch (error: any) {
      notification.error({
        message: 'Error',
        description: error.response?.data?.error || 'Failed to remove user',
      });
    }
  };

  const handleSaveWorkspaceName = () => {
    if (!selectedWorkspace) return;
    
    setEditingWorkspaceName(false);
    
    updateWorkspaceName(selectedWorkspace.id, workspaceName).then(() => {
      // Update selectedWorkspace state
      setSelectedWorkspace(prev => {
        if (!prev) return null;
        return {
          ...prev,
          name: workspaceName
        };
      });

      // Update workspaces list
      setWorkspaces(prev => 
        prev.map(workspace => 
          workspace.id === selectedWorkspace.id 
            ? { ...workspace, name: workspaceName }
            : workspace
        )
      );

      // Trigger global workspace refresh for header component
      refreshWorkspaces();

      notification.success({
        message: 'Workspace Updated',
        description: `Workspace name has been updated to ${workspaceName}`,
      });
    }).catch(error => {
      // Revert the local workspaceName state on error
      setWorkspaceName(selectedWorkspace.name);
      notification.error({
        message: 'Error',
        description: error.response?.data?.error || 'Failed to update workspace name',
      });
    });
  };

  const handleCreateWorkspace = async () => {
    if (!newWorkspaceName.trim()) {
      notification.error({
        message: 'Error',
        description: 'Please enter a workspace name',
      });
      return;
    }

    setCreateWorkspaceLoading(true);

    try {
      await create_workspace(newWorkspaceName);
      
      // Refresh workspaces list
      const updatedWorkspaces = await list_user_workspaces();
      if (Array.isArray(updatedWorkspaces)) {
        const formattedWorkspaces = updatedWorkspaces.map(workspace => ({
          ...workspace,
          members: workspace.member_count || workspace.users?.length || 1,
          users: workspace.users || [],
          alias_email: workspace.alias_email || '',
        }));
        setWorkspaces(formattedWorkspaces);
      }

      // Trigger global workspace refresh for header component
      refreshWorkspaces();

      setNewWorkspaceName('');
      setCreateWorkspaceModalVisible(false);
      
      notification.success({
        message: 'Workspace Created',
        description: `Workspace "${newWorkspaceName}" has been created successfully`,
      });

    } catch (error: any) {
        if (error.response?.status === 403 && error.response?.data?.error?.includes('SharePoint license is missing')) {
        notification.error({
          message: 'Error',
          description: 'You do not have SPO license to create a workspace.',
        });
      } else {
        notification.error({
          message: 'Error',
          description: 'Failed to create workspace. Please try again.',
        });
      }
    } finally {
      setCreateWorkspaceLoading(false);
    }
  };

  const handleDeleteWorkspace = (workspace: Workspace) => {
    if (!workspace.is_owner) {
      notification.error({
        message: 'Error',
        description: 'Only workspace owners can delete workspaces',
      });
      return;
    }

    Modal.confirm({
      title: 'Delete Workspace',
      icon: <ExclamationCircleOutlined />,
      content: `Are you sure you want to delete "${workspace.name}"? This action cannot be undone and will remove all workspace data.`,
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          await delete_workspace(workspace.id);
          
          // Remove workspace from local state
          setWorkspaces(prev => prev.filter(w => w.id !== workspace.id));
          
          // Close workspace modal if this workspace was selected
          if (selectedWorkspace?.id === workspace.id) {
            setWorkspaceModalVisible(false);
            setSelectedWorkspace(null);
          }
          
          // Trigger global workspace refresh for header component
          refreshWorkspaces();
          
          notification.success({
            message: 'Workspace Deleted',
            description: `Workspace "${workspace.name}" has been deleted successfully`,
          });
          
        } catch (error: any) {
          notification.error({
            message: 'Error',
            description: error.response?.data?.error || 'Failed to delete workspace',
          });
        }
      },
    });
  };

  return (
    <StandartLayout>
      <Layout style={{ 
        width: '100%',
        background: COLORS.background, 
        padding: isMobile ? `${SIZES.spacing.sm} ${SIZES.spacing.sm}` : `${SIZES.spacing.xl} ${SIZES.spacing.lg}`, 
        fontFamily: "'Montserrat', sans-serif",
      }}>
        {/* First row - Profile and Password */}
        <Row gutter={[32, 32]}>
          <Col xs={24} lg={14} xl={12}>
            <Card 
              title={
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                  gap: SIZES.spacing.sm
                }}>
                  <Title level={4} style={{ margin: 0, color: COLORS.textPrimary }}>Profile Information</Title>
                  <div style={{ display: 'flex', gap: SIZES.spacing.xs }}>
                    {isEditing && (
                      <Button 
                        onClick={handleCancelEdit}
                        shape="round"
                        style={{ 
                          ...buttonStyle.secondary,
                        }}
                      >
                        Cancel
                      </Button>
                    )}
                    <Button 
                      type="primary" 
                      icon={isEditing ? <SaveOutlined /> : <EditOutlined />} 
                      onClick={toggleEdit}
                      shape="round"
                      style={{ 
                        ...buttonStyle.primary,
                        background: COLORS.buttonPrimary, 
                        color: COLORS.background,
                      }}
                    >
                      {isEditing ? 'Save' : 'Edit'}
                    </Button>
                  </div>
                </div>
              }
              bordered={false}
              style={cardStyle}
              headStyle={cardHeadStyle}
              bodyStyle={cardBodyStyle}
            >
              <div style={containerStyle}>
                {isEditing ? (
                  <Form 
                    layout="vertical"
                    form={profileForm}
                    initialValues={profile}
                    onValuesChange={(changedValues, allValues) => {
                      setProfile(allValues);
                    }}
                  >
                    <Row gutter={[16, 16]}>
                      <ConfigProvider
                            theme={{
                                token: {
                                  colorText: COLORS.textPrimary,
                                  colorBorder: COLORS.border,
                                  colorBgContainer: COLORS.inputBg,
                                  colorTextDisabled: COLORS.textMuted,
                                  colorTextPlaceholder: COLORS.textMuted,
                                },
                            components: {
                              Input: {
                                activeBorderColor: COLORS.buttonPrimary,
                                activeShadow: "0",
                              }
                            },
                          }}
                        >
                        <Col xs={24} md={isMobile ? 24 : 12}>
                        
                          <Form.Item 
                            label={<span style={{ color: COLORS.textSecondary }}>Name</span>} 
                            style={{ marginBottom: SIZES.spacing.md }}
                            name="name"
                          >
                            
                              <Input
                                placeholder="Name"
                                size="large"
                              />
                          </Form.Item>
                        </Col>
                      </ConfigProvider>
                      
                      <Col xs={24} md={isMobile ? 24 : 12}>
                        <ConfigProvider
                              theme={{
                                token: {
                                  colorText: COLORS.textPrimary,
                                  colorBorder: COLORS.border,
                                  colorBgContainer: COLORS.inputBg,
                                  colorTextDisabled: COLORS.textMuted,
                                  colorTextPlaceholder: COLORS.textMuted,
                                },
                              components: {
                                Input: {
                                  activeBorderColor: COLORS.buttonPrimary,
                                  activeShadow: "0",
                                  colorTextPlaceholder: COLORS.textMuted
                                }
                              },
                              }}
                            >
                        <Form.Item 
                          label={<span style={{ color: COLORS.textSecondary }}>Surname</span>} 
                          style={{ marginBottom: SIZES.spacing.md }}
                          name="surname"
                        >
                          
                            <Input
                              placeholder="Surname"
                              size="large"
                            />
                        </Form.Item>
                        </ConfigProvider>
                      </Col>
                      
                      <Col xs={24}>
                        <ConfigProvider
                          theme={{
                            token: {
                              colorText: COLORS.textPrimary,
                              colorBorder: COLORS.border,
                              colorBgContainer: COLORS.inputBg,
                              colorTextDisabled: COLORS.textMuted,
                              colorTextPlaceholder: COLORS.textMuted,
                              colorError: '#ff4d4f',
                              colorErrorBorder: '#ff4d4f',
                              colorErrorHover: '#ff7875',
                            },
                            components: {
                              Form: {
                                colorError: '#ff4d4f',
                                colorErrorText: '#ff4d4f',
                              },
                            }
                          }}
                        >
                          <Form.Item 
                            label={<span style={{ color: COLORS.textSecondary }}>Phone</span>} 
                            style={{ marginBottom: 0 }}
                            name="phone"
                            rules={[
                              {
                                pattern: /^\+?[1-9]\d{1,14}$/,
                                message: 'Please enter a valid phone number (e.g., +1234567890 or 1234567890)',
                              },
                              {
                                min: 10,
                                message: 'Phone number must be at least 10 digits',
                              },
                              {
                                max: 17,
                                message: 'Phone number cannot exceed 17 characters',
                              }
                            ]}
                          >
                            <Input
                              placeholder="Phone (e.g., +1234567890)"
                              size="large"
                              prefix={<PhoneOutlined style={{ color: COLORS.textMuted }} />}
                            />
                          </Form.Item>
                        </ConfigProvider>
                      </Col>
                    </Row>
                  </Form>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: SIZES.spacing.sm }}>
                    {[
                      { label: "Name", value: profile.name },
                      { label: "Surname", value: profile.surname },
                      { label: "Phone", value: profile.phone },
                      { 
                        label: "Email", 
                        value: (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            <MailOutlined style={{ color: COLORS.textMuted }} />
                            {username}
                          </div>
                        ) 
                      }
                    ].map((item, index) => (
                      <div 
                        key={index}
                        style={{ 
                          display: 'flex', 
                          flexDirection: isMobile ? 'column' : 'row',
                          marginBottom: index < 3 ? SIZES.spacing.sm : 0,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        <div style={{ 
                          fontWeight: '500',
                          color: COLORS.textSecondary, 
                          background: COLORS.inputBg,
                          padding: SIZES.spacing.sm,
                          borderRadius: SIZES.spacing.xs,
                          width: isMobile ? '100%' : '120px',
                        }}>
                          {item.label}
                        </div>
                        <div style={{ 
                          flex: 1,
                          fontWeight: '400',
                          color: !item.value ? COLORS.textMuted : COLORS.textPrimary,
                          background: COLORS.contentBg,
                          padding: SIZES.spacing.sm,
                          borderRadius: isMobile ? `0 0 ${SIZES.spacing.xs} ${SIZES.spacing.xs}` : `0 ${SIZES.spacing.xs} ${SIZES.spacing.xs} 0`,
                        }}>
                          {item.value || 'Not Provided'}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Card>
          </Col>
          
          <Col xs={24} lg={12}>
            <Card 
              title={<Title level={4} style={{ margin: 0, color: COLORS.textPrimary }}>Change Password</Title>}
              bordered={false}
              style={cardStyle}
              headStyle={cardHeadStyle}
              bodyStyle={cardBodyStyle}
            >
              <div style={containerStyle}>
                <Text style={{ display: 'block', marginBottom: SIZES.spacing.lg, color: COLORS.textMuted }}>
                  Set a new password
                </Text>
                
                <ConfigProvider
                  theme={{
                    token: {
                      colorText: COLORS.textPrimary,
                      colorBorder: COLORS.border,
                      colorBgContainer: COLORS.inputBg,
                      colorTextDisabled: COLORS.textMuted,
                      colorTextPlaceholder: COLORS.textMuted,
                      colorError: '#ff4d4f',
                      colorErrorBorder: '#ff4d4f',
                      colorErrorHover: '#ff7875',
                    },
                    components: {
                      Form: {
                        colorError: '#ff4d4f',
                        colorErrorText: '#ff4d4f',
                      },
                      Input: {
                        colorText: COLORS.textPrimary,
                        colorBorder: COLORS.border,
                        colorBgContainer: COLORS.inputBg,
                        colorTextDisabled: COLORS.textMuted,
                        colorTextPlaceholder: COLORS.textMuted,
                      }
                    }
                  }}
                >
                  <Form 
                    form={passwordForm}
                    layout="vertical"
                    onFinish={onPasswordFormFinish}
                    onFinishFailed={onPasswordFormFinishFailed}
                    requiredMark={false}
                    size="large"
                    validateTrigger={['onChange', 'onBlur']}
                  >
                    <Form.Item
                      name="password"
                      label={<span style={{ color: COLORS.textSecondary }}>New Password</span>}
                      rules={[
                        { required: true, message: 'Please input your new password!' },
                        { min: 8, message: 'Password must be at least 8 characters' }
                      ]}
                      style={{ marginBottom: SIZES.spacing.md }}
                    >
                      <Input.Password
                        prefix={<LockOutlined style={{ color: COLORS.textMuted }} />}
                        placeholder="New Password"
                        className="password-input-custom"
                      />
                    </Form.Item>
                    
                    <Form.Item
                      name="confirmPassword"
                      label={<span style={{ color: COLORS.textSecondary }}>Confirm Password</span>}
                      dependencies={['password']}
                      rules={[
                        { required: true, message: 'Please confirm your password!' },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue('password') === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject(new Error('The passwords do not match!'));
                          },
                        }),
                      ]}
                      style={{ marginBottom: SIZES.spacing.lg }}
                    >
                      <Input.Password
                        prefix={<LockOutlined style={{ color: COLORS.textMuted }} />}
                        placeholder="Confirm Password"
                        className="password-input-custom"
                      />
                    </Form.Item>
                    
                    <Form.Item>
                      <Button 
                        type="primary" 
                        htmlType="submit" 
                        block 
                        size="large"
                        shape="round"
                        loading={passwordLoading}
                        style={buttonStyle.primary}
                      >
                        Update Password
                      </Button>
                    </Form.Item>
                  </Form>
                </ConfigProvider>
              </div>
            </Card>
          </Col> 
        </Row>
        
        {/* Second row - Integrations and Workspaces */}
        <Row gutter={[32, 32]} style={{ marginTop: SIZES.spacing.xl }}>
          <Col xs={24} lg={12}>
            <Card 
              title={
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: SIZES.spacing.sm
                }}>
                  <ApiOutlined style={{ color: COLORS.buttonPrimary }} />
                  <Title level={4} style={{ margin: 0, color: COLORS.textPrimary }}>Integrations</Title>
                </div>
              }
              bordered={false}
              style={cardStyle}
              headStyle={cardHeadStyle}
              bodyStyle={cardBodyStyle}
            >
              <div style={containerStyle}>
                <Text style={{ display: 'block', marginBottom: SIZES.spacing.lg, color: COLORS.textMuted }}>
                  Connect your accounts for enhanced features
                </Text>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: SIZES.spacing.md }}>
                  {/* Microsoft Integration */}
                  {isMobile ? (
                    // Mobile view - show auth button if not connected, or toggle switch if connected
                    <div style={{ 
                      display: 'flex', 
                      flexDirection: 'column',
                      gap: SIZES.spacing.sm,
                      padding: SIZES.spacing.md,
                      background: COLORS.contentBg,
                      borderRadius: SIZES.spacing.xs,
                      border: `1px solid ${COLORS.border}`
                    }}>
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'space-between'
                      }}>
                        <Text style={{ color: COLORS.textPrimary, fontWeight: '500' }}>
                          Microsoft Account
                        </Text>
                        {microsoftConnected && (
                          <Switch 
                            checked={microsoftConnected}
                            onChange={handleMicrosoftToggle}
                            style={{
                              backgroundColor: microsoftConnected ? COLORS.successColor : COLORS.border
                            }}
                          />
                        )}
                      </div>
                      {!microsoftConnected && <MicrosoftAuth disabled={false} />}
                    </div>
                  ) : (
                    // Desktop view - full integration card
                    <div 
                      style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'space-between',
                        padding: SIZES.spacing.md,
                        background: COLORS.contentBg,
                        borderRadius: SIZES.spacing.xs,
                        border: `1px solid ${COLORS.border}`
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: SIZES.spacing.sm }}>
                        <div style={{ 
                          width: '32px', 
                          height: '32px', 
                          borderRadius: '50%', 
                          background: microsoftConnected ? COLORS.successColor : COLORS.border,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          {microsoftConnected ? 
                            <CheckCircleOutlined style={{ color: 'white', fontSize: '16px' }} /> :
                            <LinkOutlined style={{ color: COLORS.textMuted, fontSize: '16px' }} />
                          }
                        </div>

                        <div>
                          <Text style={{ color: COLORS.textPrimary, fontWeight: '500' }}>
                            Microsoft Account
                          </Text>
                          <div style={{ color: COLORS.textMuted, fontSize: '12px' }}>
                            {microsoftConnected ? 'Connected' : 'Not Connected'}
                          </div>
                        </div>
                        
                      </div>
                      {!microsoftConnected && (
                      <MicrosoftAuth disabled={false} />
                      )}
                      
                      {/* Toggle switch for Microsoft connection */}
                      {microsoftConnected && (
                        <Switch 
                          checked={microsoftConnected}
                          onChange={handleMicrosoftToggle}
                          style={{
                            backgroundColor: microsoftConnected ? COLORS.successColor : COLORS.border
                          }}
                        />
                      )}
                    </div>
                  )}

                  {/* Slack Integration */}
                  {isMobile ? (
                    // Mobile view - show auth button if not connected, or toggle switch if connected
                    <div style={{ 
                      display: 'flex', 
                      flexDirection: 'column',
                      gap: SIZES.spacing.sm,
                      padding: SIZES.spacing.md,
                      background: COLORS.contentBg,
                      borderRadius: SIZES.spacing.xs,
                      border: `1px solid ${COLORS.border}`
                    }}>
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'space-between'
                      }}>
                        <div>
                          <Text style={{ color: COLORS.textPrimary, fontWeight: '500' }}>
                            Slack
                          </Text>
                          {slackConnected && slackWorkspaceName && (
                            <div style={{ color: COLORS.textMuted, fontSize: '12px' }}>
                              {slackWorkspaceName}
                            </div>
                          )}
                        </div>
                        {slackConnected && (
                          <Switch 
                            checked={slackConnected}
                            onChange={handleSlackToggle}
                            style={{
                              backgroundColor: slackConnected ? COLORS.successColor : COLORS.border
                            }}
                          />
                        )}
                      </div>
                      {!slackConnected && <SlackAuth disabled={false} />}
                    </div>
                  ) : (
                    // Desktop view - full integration card
                    <div 
                      style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'space-between',
                        padding: SIZES.spacing.md,
                        background: COLORS.contentBg,
                        borderRadius: SIZES.spacing.xs,
                        border: `1px solid ${COLORS.border}`
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: SIZES.spacing.sm }}>
                        <div style={{ 
                          width: '32px', 
                          height: '32px', 
                          borderRadius: '50%', 
                          background: slackConnected ? COLORS.successColor : COLORS.border,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          {slackConnected ? 
                            <CheckCircleOutlined style={{ color: 'white', fontSize: '16px' }} /> :
                            <LinkOutlined style={{ color: COLORS.textMuted, fontSize: '16px' }} />
                          }
                        </div>

                        <div>
                          <Text style={{ color: COLORS.textPrimary, fontWeight: '500' }}>
                            Slack
                          </Text>
                            <div style={{ color: COLORS.textMuted, fontSize: '12px' }}>
                              {slackConnected 
                                ? (slackWorkspaceName ? slackWorkspaceName : 'Connected') 
                                : 'Not Connected'
                              }
                          </div>
                        </div>
                        
                      </div>
                      {!slackConnected && (
                      <SlackAuth disabled={false} />
                      )}
                      
                      {/* Toggle switch for Slack connection */}
                      {slackConnected && (
                        <Switch 
                          checked={slackConnected}
                          onChange={handleSlackToggle}
                          style={{
                            backgroundColor: slackConnected ? COLORS.successColor : COLORS.border
                          }}
                        />
                      )}
                    </div>
                  )}

                  {/* Fireflies Integration */}
                  {isMobile ? (
                    // Mobile view - show auth button if not connected, or toggle switch if connected
                    <div style={{ 
                      display: 'flex', 
                      flexDirection: 'column',
                      gap: SIZES.spacing.sm,
                      padding: SIZES.spacing.md,
                      background: COLORS.contentBg,
                      borderRadius: SIZES.spacing.xs,
                      border: `1px solid ${COLORS.border}`,
                      cursor: firefliesConnected ? 'pointer' : 'default',
                    }}
                    onClick={() => firefliesConnected && setFirefliesModalVisible(true)}
                    >
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'space-between'
                      }}>
                        <Text style={{ color: COLORS.textPrimary, fontWeight: '500' }}>
                          Fireflies.ai
                        </Text>
                        {firefliesConnected && (
                          <Switch 
                            checked={firefliesConnected}
                            onChange={handleFirefliesToggle}
                            onClick={(checked, e) => e.stopPropagation()}
                            style={{
                              backgroundColor: firefliesConnected ? COLORS.successColor : COLORS.border
                            }}
                          />
                        )}
                      </div>
                      {!firefliesConnected && (
                        <FirefliesAuth 
                          disabled={false} 
                          onTokenReceived={() => {
                            setFirefliesConnected(true);
                          }}
                        />
                      )}
                    </div>
                  ) : (
                    // Desktop view - full integration card
                    <div 
                      style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'space-between',
                        padding: SIZES.spacing.md,
                        background: COLORS.contentBg,
                        borderRadius: SIZES.spacing.xs,
                        border: `1px solid ${COLORS.border}`,
                        cursor: firefliesConnected ? 'pointer' : 'default',
                      }}
                      onClick={() => firefliesConnected && setFirefliesModalVisible(true)}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: SIZES.spacing.sm }}>
                        <div style={{ 
                          width: '32px', 
                          height: '32px', 
                          borderRadius: '50%', 
                          background: firefliesConnected ? COLORS.successColor : COLORS.border,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          {firefliesConnected ? 
                            <CheckCircleOutlined style={{ color: 'white', fontSize: '16px' }} /> :
                            <LinkOutlined style={{ color: COLORS.textMuted, fontSize: '16px' }} />
                          }
                        </div>

                        <div>
                          <Text style={{ color: COLORS.textPrimary, fontWeight: '500' }}>
                            Fireflies.ai
                          </Text>
                          <div style={{ color: COLORS.textMuted, fontSize: '12px' }}>
                            {firefliesConnected ? 'Connected - Click to manage' : 'Not Connected'}
                          </div>
                        </div>
                        
                      </div>

                      {!firefliesConnected && (
                      <FirefliesAuth 
                        disabled={false} 
                        onTokenReceived={() => {
                          setFirefliesConnected(true);
                        }}
                      />
                      )}
                      
                      {/* Toggle switch for Fireflies connection */}
                      {firefliesConnected && (
                        <Switch 
                          checked={firefliesConnected}
                          onChange={handleFirefliesToggle}
                          onClick={(checked, e) => e.stopPropagation()}
                          style={{
                            backgroundColor: firefliesConnected ? COLORS.successColor : COLORS.border
                          }}
                        />
                      )}
                    </div>
                  )}
                
                </div>
              </div>
            </Card>
          </Col>
          
          <Col xs={24} lg={12}>
            <Card 
              title={
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                  gap: SIZES.spacing.sm
                }}>
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: SIZES.spacing.sm
                  }}>
                    <TeamOutlined style={{ color: COLORS.buttonPrimary }} />
                    <Title level={4} style={{ margin: 0, color: COLORS.textPrimary }}>Workspaces</Title>
                  </div>
                  <Button 
                    type="primary" 
                    icon={<UserAddOutlined />} 
                    onClick={() => setCreateWorkspaceModalVisible(true)}
                    shape="round"
                    size="small"
                    style={{ 
                      ...buttonStyle.primary,
                      background: COLORS.buttonPrimary, 
                      color: COLORS.background,
                    }}
                  >
                    New Workspace
                  </Button>
                </div>
              }
              bordered={false}
              style={cardStyle}
              headStyle={cardHeadStyle}
              bodyStyle={cardBodyStyle}
            >
              <div style={containerStyle}>
                <Text style={{ display: 'block', marginBottom: SIZES.spacing.lg, color: COLORS.textMuted }}>
                  Manage your workspaces and team members
                </Text>
                
                <div style={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  gap: SIZES.spacing.md,
                  maxHeight: '400px',
                  overflowY: 'auto',
                  paddingRight: SIZES.spacing.sm
                }}>
                  {workspaces.map((workspace) => (
                    <div 
                      key={workspace.id}
                      style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'space-between',
                        padding: SIZES.spacing.md,
                        background: COLORS.contentBg,
                        borderRadius: SIZES.spacing.xs,
                        border: `1px solid ${COLORS.border}`,
                        transition: 'all 0.3s ease',
                      }}
                    >
                      <div 
                        onClick={() => handleWorkspaceClick(workspace)}
                        style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          gap: SIZES.spacing.sm,
                          flex: 1,
                          cursor: 'pointer'
                        }}
                      >
                        <div style={{ 
                          width: '32px', 
                          height: '32px', 
                          borderRadius: SIZES.spacing.xs, 
                          background: COLORS.border,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <TeamOutlined style={{ 
                            color: COLORS.textMuted, 
                            fontSize: '16px' 
                          }} />
                        </div>
                        <div>
                          <Text style={{ color: COLORS.textPrimary, fontWeight: '500' }}>
                            {workspace.name}
                          </Text>
                          <div style={{ color: COLORS.textMuted, fontSize: '12px' }}>
                            {workspace.members} members
                          </div>
                        </div>
                      </div>

                        
                      {workspace.is_owner && (
                        <Button
                          type="text"
                          icon={<DeleteOutlined />}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteWorkspace(workspace);
                          }}
                          style={{ 
                            color: '#ff4d4f',
                            border: 'none',
                            background: 'transparent'
                          }}
                          size="small"
                        />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </Card>
          </Col>
        </Row>

        {/* Workspace Modal */}
        <Modal
          title={null}
          open={workspaceModalVisible}
          onCancel={() => setWorkspaceModalVisible(false)}
          footer={null}
          width={600}
          closeIcon={ <CloseOutlined style={{ color: COLORS.textMuted }} /> }
          styles={{
            content: {
              background: COLORS.cardBg,
              border: `1px solid ${COLORS.border}`,
            },
            header: {
              background: COLORS.cardBg,
              borderBottom: `1px solid ${COLORS.border}`,
            }
          }}
        >
          {selectedWorkspace && (
            <div>
              {/* Header */}
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                marginBottom: SIZES.spacing.lg,
                paddingBottom: SIZES.spacing.md,
                borderBottom: `1px solid ${COLORS.border}`
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: SIZES.spacing.sm }}>
                  {editingWorkspaceName ? (
                    <ConfigProvider
                      theme={{
                        token: {
                          colorText: COLORS.textPrimary,
                          colorBorder: COLORS.border,
                          colorBgContainer: COLORS.inputBg,
                          colorTextDisabled: COLORS.textMuted,
                          colorTextPlaceholder: COLORS.textMuted,
                        },
                      }}
                    >
                      <Input
                        value={workspaceName}
                        onChange={(e) => setWorkspaceName(e.target.value)}
                        onPressEnter={handleSaveWorkspaceName}
                        onBlur={handleSaveWorkspaceName}
                        autoFocus
                      />
                    </ConfigProvider>
                  ) : (
                    <Title level={4} style={{ margin: 0, color: COLORS.textPrimary }}>
                      {selectedWorkspace.name}
                    </Title>
                  )}
                  <Button
                    type="text"
                    icon={<EditOutlined />}
                    onClick={() => setEditingWorkspaceName(!editingWorkspaceName)}
                    style={{ color: COLORS.textMuted }}
                  />
                </div>
              </div>

              {/* Workspace Alias Email */}
              {selectedWorkspace.alias_email && (
                <div style={{ 
                  marginBottom: SIZES.spacing.lg,
                  padding: SIZES.spacing.md,
                  background: COLORS.contentBg,
                  borderRadius: SIZES.spacing.xs,
                  border: `1px solid ${COLORS.border}`
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: SIZES.spacing.sm, marginBottom: SIZES.spacing.xs }}>
                    <MailOutlined style={{ color: COLORS.buttonPrimary }} />
                    <Text style={{ color: COLORS.textSecondary, fontWeight: '500' }}>
                      Tommy Agent Email
                    </Text>
                    {/* Copy email */}
                    <Button
                      type="text"
                      icon={<CopyOutlined />}
                      onClick={() => {
                        navigator.clipboard.writeText(selectedWorkspace.alias_email);
                        message.success('Email copied to clipboard');
                      }}
                      style={{ color: COLORS.textMuted }}
                      size="small"
                    />

                  </div>
                  <Text style={{ 
                    color: COLORS.textPrimary, 
                    fontFamily: 'monospace',
                    fontSize: '14px',
                    display: 'block',
                    marginBottom: SIZES.spacing.xs
                  }}>
                    {selectedWorkspace.alias_email}
                  </Text>
                  <Text style={{ color: COLORS.textMuted, fontSize: '12px' }}>
                    Add this email to CC in your messages to keep Tommy agent in the loop
                  </Text>
                </div>
              )}

              {/* Invite User */}
              <div style={{ marginBottom: SIZES.spacing.lg }}>
                <Text style={{ color: COLORS.textSecondary, display: 'block', marginBottom: SIZES.spacing.sm }}>
                  Invite new member
                </Text>
                <div style={{ display: 'flex', gap: SIZES.spacing.sm }}>
                  <ConfigProvider
                    theme={{
                      components: {
                        Input: {
                          colorText: COLORS.textPrimary,
                          colorBorder: COLORS.border,
                          colorBgContainer: COLORS.inputBg,
                          colorTextDisabled: COLORS.textMuted,
                          colorTextPlaceholder: COLORS.textMuted,
                        },
                      },
                    }}
                    >
                      <Input
                        placeholder="Enter email address"
                        value={inviteEmail}
                        onChange={(e) => setInviteEmail(e.target.value)}
                      onPressEnter={handleInviteUser}
                    />
                  </ConfigProvider>
                  <Button
                    type="primary"
                    icon={<UserAddOutlined />}
                    onClick={handleInviteUser}
                    loading={inviteLoading}
                    style={buttonStyle.primary}
                  >
                    Invite
                  </Button>
                </div>
              </div>

              {/* Users List */}
              <div>
                <Text style={{ color: COLORS.textSecondary, display: 'block', marginBottom: SIZES.spacing.md }}>
                  Team Members
                </Text>
                <List
                  style={{ maxHeight: 300, overflowY: 'auto' }}
                  dataSource={selectedWorkspace.users}
                  renderItem={(user: User) => (
                    <List.Item
                      style={{
                        background: COLORS.contentBg,
                        marginBottom: SIZES.spacing.xs,
                        borderRadius: SIZES.spacing.xs,
                        border: `1px solid ${COLORS.border}`,
                        padding: SIZES.spacing.md
                      }}
                      actions={[
                        <Tag color={user.role === 'Admin' ? 'blue' : 'default'}>
                          {user.role}
                        </Tag>,
                        user.role !== 'admin' && (
                          <Button
                            type="text"
                            icon={<CloseOutlined />}
                            onClick={() => handleRemoveUser(user.email)}
                            style={{ color: COLORS.textMuted }}
                            size="small"
                          />
                        )
                      ].filter(Boolean)}
                    >
                      <List.Item.Meta
                        avatar={<Avatar icon={<UserOutlined />} style={{ background: COLORS.border }} />}
                        title={<span style={{ color: COLORS.textPrimary }}>{user.name}</span>}
                        description={<span style={{ color: COLORS.textMuted }}>{user.email}</span>}
                      />
                    </List.Item>
                  )}
                />
              </div>
            </div>
          )}
        </Modal>

        {/* Create Workspace Modal */}
        <Modal
          title={null}
          open={createWorkspaceModalVisible}
          onCancel={() => {
            setCreateWorkspaceModalVisible(false);
            setNewWorkspaceName('');
          }}
          footer={null}
          width={400}
          styles={{
            content: {
              background: COLORS.cardBg,
              border: `1px solid ${COLORS.border}`,
            },
            header: {
              background: COLORS.cardBg,
              borderBottom: `1px solid ${COLORS.border}`,
            }
          }}
        >
          <div>
            {/* Header */}
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: SIZES.spacing.sm,
              marginBottom: SIZES.spacing.lg,
              paddingBottom: SIZES.spacing.md,
              borderBottom: `1px solid ${COLORS.border}`
            }}>
              <TeamOutlined style={{ color: COLORS.buttonPrimary }} />
              <Title level={4} style={{ margin: 0, color: COLORS.textPrimary }}>
                Create New Workspace
              </Title>
            </div>

            {/* Form */}
            <div style={{ marginBottom: SIZES.spacing.lg }}>
              <Text style={{ color: COLORS.textSecondary, display: 'block', marginBottom: SIZES.spacing.sm }}>
                Workspace Name
              </Text>
              <ConfigProvider
                theme={{
                  components: {
                    Input: {
                      colorText: COLORS.textPrimary,
                      colorBorder: COLORS.border,
                      colorBgContainer: COLORS.inputBg,
                      colorTextDisabled: COLORS.textMuted,
                      colorTextPlaceholder: COLORS.textMuted,
                    },
                  },
                }}
              >
                <Input
                  placeholder="Enter workspace name"
                  value={newWorkspaceName}
                  onChange={(e) => setNewWorkspaceName(e.target.value)}
                  onPressEnter={handleCreateWorkspace}
                  size="large"
                />
              </ConfigProvider>
            </div>

            {/* Actions */}
            <div style={{ display: 'flex', gap: SIZES.spacing.sm, justifyContent: 'flex-end' }}>
              <Button
                onClick={() => {
                  setCreateWorkspaceModalVisible(false);
                  setNewWorkspaceName('');
                }}
                style={{
                  ...buttonStyle.secondary,
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={handleCreateWorkspace}
                loading={createWorkspaceLoading}
                style={buttonStyle.primary}
              >
                Create Workspace
              </Button>
            </div>
          </div>
        </Modal>
      </Layout>
    </StandartLayout>
  );
}

export default Settings;